import { render } from "./ContactoForm.vue?vue&type=template&id=4307fbce"
import script from "./ContactoForm.vue?vue&type=script&lang=js"
export * from "./ContactoForm.vue?vue&type=script&lang=js"
script.render = render

export default script